import React, { useMemo } from 'react';
import { Cookies } from 'react-cookie';

import RoleSideNav from './RoleSideNav';
import { NavContext } from './sideNavConfig';

/**
 * Customer navigation wrapper. The shared RoleSideNav owns the rail, collapse
 * persistence, and logout confirmation so every role uses one product shell.
 */
const Navbar: React.FC = () => {
  const cookies = new Cookies();
  const userRole = cookies.get('role');
  const user = cookies.get('user');
  const superUser = cookies.get('super_user');
  const isSpectator = user?.company_scope === 'SPECTATOR';
  const isReadOnly = userRole === 'READ_ONLY';

  const shouldDisableNavigation =
    (userRole === 'ADMIN' ||
      userRole === 'OPERATIONS' ||
      userRole === 'READ_ONLY') &&
    user?.accepted_terms === false &&
    superUser === false;

  const navContext: NavContext = useMemo(
    () => ({ isSpectator, isReadOnly }),
    [isSpectator, isReadOnly]
  );

  return (
    <RoleSideNav
      context={navContext}
      disabled={shouldDisableNavigation}
      ariaLabel="Customer navigation"
      collapseStorageKey="gc_nav_collapsed_v1"
      openStorageKey="gc_nav_open_v1"
    />
  );
};

export default Navbar;
